import store from '../store'
import { SET_CURRENT_RECORDING } from '../types'

export const setAudioRecording = (recording: any) => {
  store.dispatch({
    type: SET_CURRENT_RECORDING,
    payload: recording,
  })
}
